import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { getCategoryNavigationFromRelewiseCategorySearch } from '../services/CategoryService';
import { CategoryNavigationResponse } from '../types/mapped';

const EMPTY_CATEGORY_NAVIGATION: CategoryNavigationResponse = {
    currentCategory: null,
    parentCategory: null,
    navigationItems: []
};

export class GetCategoryNavigationDataInput implements IActionInput {
    public categoryRecordId: string | undefined;

    public constructor(categoryRecordId: string | undefined) {
        this.categoryRecordId = categoryRecordId;
    }

    public getCacheKey = () => `RelewiseCategoryNavigation-${this.categoryRecordId ?? 'none'}`;

    public getCacheObjectType = () => 'RelewiseCategoryNavigation';

    public dataCacheType = (): CacheType => 'request';
}

const createInput = (inputData: ICreateActionContext) => {
    return new GetCategoryNavigationDataInput(inputData.requestContext.urlTokens.recordId);
};

export async function getCategoryNavigationData(
    input: GetCategoryNavigationDataInput,
    ctx: IActionContext
): Promise<CategoryNavigationResponse> {
    if (!input.categoryRecordId) {
        const message = '[getProductListCategoryNavigationData] Missing categoryRecordId. Returning empty category navigation';
        console.error(message);
        ctx.telemetry.error(message);
        return EMPTY_CATEGORY_NAVIGATION;
    }

    const result = await getCategoryNavigationFromRelewiseCategorySearch(ctx.requestContext, ctx.telemetry, input.categoryRecordId);
    return result ?? EMPTY_CATEGORY_NAVIGATION;
}

export const getCategoryNavigationDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/custom/get-category-navigation',
    action: <IAction<CategoryNavigationResponse>>getCategoryNavigationData,
    input: createInput
});

export default getCategoryNavigationDataAction;
